module.exports = __webpack_public_path__ + "store/img/QRCodePlaceholder.c8891a5b.svg";